export enum ExpressServiceStatus {
  CREATED = 1,
  WAITING = 2,
  ASSIGNED = 3,
  IN_PROCESS = 4,
  END = 5,
  CANCELED = 6,
  END_FAILED = 8,
  RELAUNCHED = 8.1,
}
